<div *ngIf="router.url.includes('Summer-play')" id="deskMap"></div>
<div *ngIf="router.url.includes('Field-meander')" id="deskMap1"></div>
<div *ngIf="router.url.includes('Field-bio')" id="deskMap2"></div>